export default {"src":"/_next/static/image/public/images/ic_copy_referral.f4f38e70300b7dbb0f8b7a2bdc588fe3.svg","height":32,"width":32};